import { Toast } from 'vant'


export function checkPhone(data){
    if(!(/^1[3|4|5|7|8]\d{9}$/.test(data))){
        Toast('请输入正确电话号码')
        return true
    }else{
        return false
    }

    
}